// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// // Import the functions you need from the SDKs you need

// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyCJMrL20NL0oez3Aey3OvHgoaHkj12iR3o",
//   authDomain: "designer-3b460.firebaseapp.com",
//   projectId: "designer-3b460",
//   storageBucket: "designer-3b460.appspot.com",
//   messagingSenderId: "273093005078",
//   appId: "1:273093005078:web:50792d423e7a8416e5ca37"
// };

// // Initialize Firebase


// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// export default auth;

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBV1DRF75S7es-cO-qKmqcRmAYGQYrRcIc",
  authDomain: "assainment-3fdcb.firebaseapp.com",
  projectId: "assainment-3fdcb",
  storageBucket: "assainment-3fdcb.appspot.com",
  messagingSenderId: "780478703232",
  appId: "1:780478703232:web:776415aaaab1ea04362865"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;
